import axios from 'axios'
import qs from 'qs'
import {
	message
} from 'ant-design-vue'
import router from '../router/router.js';
axios.defaults.timeout = 200000;

axios.defaults.baseURL = process.env.VUE_APP_BASE_API + "/";
//POST传参序列化
axios.interceptors.request.use((config) => {
	if (config.method === 'post') {
		if (config.headers['Content-Type'] !== 'multipart/form-data;charset=UTF-8') {
			config.data = config.data || {};
			config.data.token = localStorage.getItem('account-token');
			config.data = qs.stringify(config.data);
		} else if (config.method === 'get') {
			
		} else { //上传文件逻辑
			config.data = config.data;
		}
	}
	return config;
}, (error) => {
	message.error('网络请求超时');

	return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((res) => {
	if (res.status == 200) {
		return res;
	} else {
		return Promise.reject(res);
	}
}, (error) => {
	//console.log(error);
	return Promise.reject(error);
});

export function upload(file) {
	if (!file) {
		return Promise.reject('未传入有效的文件对象');
	}
	var datas = new FormData();
	var configs = {
		headers: {
			'token': localStorage.getItem('account-token'),
			'Content-Type': 'multipart/form-data;charset=UTF-8'
		}
	};
	// datas.file = file
	datas.append('file',file);
	return axios.post('api/common/upload', datas, configs)
		.then(response => {
			console.log(response.data.code);
			switch (response.data.code) {
				case 1:
					return response.data.data;
				default:
					return Promise.reject(response.data.msg || 'error');
			}
		})
		.catch((msg) => {
			return Promise.reject(msg || 'error')
		});
}


export function uploadVideo(file) {
	var datas = new FormData();
	var configs = {
		headers: {
			'token': localStorage.getItem('account-token')
		}
	};
	datas.append('file', file);
	return axios.post('api/common/upload', datas, configs)
		.then(response => {
			console.log(response.data.code);
			switch (response.data.code) {
				case 1:
					return response.data.data;
				default:
					return Promise.reject(response.data.msg || 'error');
			}
		})
		.catch((msg) => {
			return Promise.reject(msg || 'error')
		});
}

export function api(url, params) {
	var configs = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			'token': localStorage.getItem('account-token')
		}
	};
	
	if(!params){
		params = {}
	}
	Object.assign(params, { common_language: localStorage.getItem('language') });
	Object.assign(params, { version: 'v1' });
	var apiUrl = 'api/'+url
	if(url.indexOf('addons')!== -1){
		apiUrl = url
	}
	return axios.post(apiUrl, params,configs)
		.then(response => {
			if(url.indexOf('addons')!== -1){
				// 走聊天接口的逻辑
				switch (response.data.code) {
					case 1:
						return response.data.data;
					default:
						return Promise.reject(response.data.msg || 'error');
				}
			}else{
				switch (response.data.code) {
					case 401:
						// 未登录
						message.error(response.data.msg);
						localStorage.removeItem('account-token');
						router.push('/login');
						return Promise.reject(response.data.msg || 'error');
					case 0:
						return response.data.data;
					case -1: //400 为提示类型错误
						message.error(response.data.msg);
						return Promise.reject(response.data.msg || 'error');
					case 1: //400 为提示类型错误
						message.error(response.data.msg);
						return Promise.reject(response.data.msg || 'error');
					case 500:
						return Promise.reject('网络繁忙');
						break;
					default:
						return Promise.reject(response.data.msg || 'error');
				}
			}
			
		})
		.catch((msg) => {
			console.log("-------------------111",msg);
			// message.error(response.data.msg);
			// localStorage.removeItem('account-token');
			// router.push('/login');
			return Promise.reject(msg || 'error')
		});

}